import {
    ColumnDto,
    RowDto,
    VariableType,
} from '../../system-configuration/table-editor';

export function rowDtoTransformer(
    formValue: { [key: string]: any },
    columns: ColumnDto[],
): RowDto {
    const row: RowDto = { cells: [] };

    columns.forEach((e) => {
        const fv = formValue[e.columnName.toLowerCase()];
        if (fv == null) {
            return;
        }

        let valueChar = null;
        let valueNumeric = null;
        let valueDateTime = null;
        let valueInteger = null;

        switch (e.variableType) {
            case VariableType.VAR_CHAR:
                valueChar = fv;
                break;
            case VariableType.NUMERIC:
                valueNumeric = parseFloat(fv);
                break;
            case VariableType.DATE_TIME:
                valueDateTime = fv;
                break;
            case VariableType.INTEGER:
                valueInteger = parseInt(fv);
                break;
        }

        row.cells.push({
            columnName: e.columnName,
            variableType: e.variableType,
            valueChar,
            valueNumeric,
            valueDateTime,
            valueInteger,
        });
    });

    return row;
}
